export const tooltipVariants = {
    DEFAULT: 'default',
    ERROR: 'error',
} as const
